import React, { Component } from 'react';
import Lottie from 'react-lottie';

export default class Document0 extends Component {
  constructor(props) {
    super(props);
    this.state = { isStopped: false, isPaused: false };
  }

  render() {

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: require('./assets/document1.json'),
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return <Lottie options={defaultOptions}
      height={100}
      width={100}
      isStopped={this.state.isStopped}
      isPaused={this.state.isPaused} />
  }
}